import {Injectable} from '@angular/core';
import {ENDPOINTS} from '~environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RequestManagerService {
  requestContextOptionsFactory(url: string, payload: any): any {
    return url.includes(ENDPOINTS.API_MICROSERVICE_BEGIN_DETAILS)
      ? { payload }
      : null;
  }
}
